import '@babel/polyfill' // NOTE - REQUIRED ON EVERY PAGE
import withRedux from 'next-redux-wrapper'
import * as React from 'react'
import SiteWrapper from '../client/components/SiteWrapper'
import ArticlePage from 'pages/ArticlePage'
import {HEADER_TYPE_ARTICLE} from '../client/constants/header'
import {makeStore} from '../client/redux'
import {setArticle, setCategories} from 'store/reducers/site'
import {LearnvestApi} from '../client/api/learnvest'
import {checkSubscriptionCookies} from 'store/actions/site'
import {handleApiUnavailableError} from '../client/utils/errors'

class Article extends React.Component {
  // static async getInitialProps ({req, store, query}) {
  //   try {
  //     const learnvestApi = new LearnvestApi(query.ajax)
  //     checkSubscriptionCookies(req, store)
  //     const articleSlug = query.id.toLowerCase()
  //     const articlePageData = await learnvestApi.fetchArticlePageData(articleSlug)
  //     store.dispatch(setArticle(articlePageData.article))
  //     store.dispatch(setCategories(learnvestApi.mapCategories(articlePageData.categories)))
  //     return {
  //       ...articlePageData,
  //       articleSlug,
  //       isMobileLayout: query.isMobileLayout
  //     }
  //   } catch (e) {
  //     return handleApiUnavailableError(e)
  //   }
  // }

  static async getInitialProps ({req, store, query}) {
    return query.data;
  }

  render () {
    const {
      article,
      articleSlug,
      relatedArticles
    } = this.props
    // console.log(JSON.stringify({ article, articleSlug, relatedArticles}))
    return (
      <SiteWrapper isMobileLayout={this.props.isMobileLayout} apiAvailable={this.props.apiAvailable} headerType={HEADER_TYPE_ARTICLE} key={articleSlug}
        isArticlePage>
        <ArticlePage article={article}
          relatedArticles={relatedArticles} key={articleSlug} />
      </SiteWrapper>
    )
  }
}

export default withRedux(makeStore)(Article)



// WEBPACK FOOTER //
// ./pages/article.js